import script from "./BrandAuthOperatorUpsert.vue?vue&type=script&lang=ts&setup=true"
export * from "./BrandAuthOperatorUpsert.vue?vue&type=script&lang=ts&setup=true"

import "./BrandAuthOperatorUpsert.vue?vue&type=style&index=0&id=4e0a814f&lang=scss"

const __exports__ = script;

export default __exports__